function SecondaryBtn({
  onClick,
  label,
  children,
  className = '',
  disabled = false,
}) {
  return (
    <button
      onClick={onClick}
      type="button"
      disabled={disabled}
      className={`
        px-5 py-2.5
        text-sm font-medium
        text-[#BA141B]
        bg-white
        border border-[#BA141B]/30
        rounded-lg
        hover:bg-[#BA141B]/5
        hover:border-[#BA141B]/50
        active:bg-[#BA141B]/10
        disabled:opacity-50 disabled:cursor-not-allowed disabled:border-gray-300 disabled:text-gray-400
        focus:outline-none focus:ring-4 focus:ring-[#BA141B]/20 focus:ring-offset-1
        transition-colors duration-150
        ${className}
      `}
    >
      {label || children}
    </button>
  )
}

export default SecondaryBtn